import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _HealthAllergies, _HealthAttentionCause, _HealthAttentionGateEntry, _HealthAttentionModality, _HealthAttentionService, _HealthAttentionSite, _HealthDiagnosisType, _HealthOrphanDisease, _HealthRegimen, _HealthTechnologyPurpose, _HealthTechnologyType, _HealthTimeUnit, _ImpHealthOrphanDisease, _IncapacityType, _PatientDischargeStatus, _RiskFactoryType, _TriageType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { HealthIDEditor } from "../../../admin/configuracion/HealthID/HealthIDEditor";
import { FileInput } from "../../../theme/Component/FileInput";
import { HealthIDTypeCatalog } from "../../../admin/configuracion/HealthID/HealthIDTypeCatalog";



export const HealthOrphanDisease = () => {

    const disease = useDataBean(_HealthOrphanDisease);
    const imp = useDataBean(_ImpHealthOrphanDisease);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [Health, setHealth] = useState<any>(null);
    const [NameSelect, setNameSelect] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalorp, setModalorp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

   useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        disease.instance.getHealthOrphanDiseaseCatalog(null,regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Icd = (user.DataBeanProperties.HealthIDCode ?? "") + "-" + (user.DataBeanProperties.HealthIDName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        disease.setBean({
            
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        disease.deleteItemVoid(disease.bean.IDHealthOrphanDisease).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
       //console.log(entailment.bean);
        disease.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDHealthOrphanDisease', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'ICD - Clasificador Internacional de Enfermedades', property: 'Icd', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${disease.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const importHealthOrphanDiseaseCatalog = () => {
        
        imp.instance.importHealthOrphanDiseaseCatalog(imp.bean.IDHealthIDType, imp.bean.Media, imp.bean.MediaContext,null).then(
          (resp: any) => {
            console.log(resp)
            setModalorp({ ...modalorp, "view": false });
          }
        ).catch(err => {
          toast.error(err);
        })
    
      }
 const verimp = () => {
        
            setModalorp({ ...modalorp, "view": true });
      }
    return (
        <BasicPage titulo="Enfermedades Huerfanas">
            <div className="row">
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-2 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verimp}>
                    Importar Catálogo de Enfermedades Huerfanas
                </BasicButton>
                </div>
                
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={disease.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                 <HealthIDEditor render={disease.bean.HealthIDName ||  NameSelect } tipoPresupuesto={30} id={null} edit={true} onSelect={(e) => { disease.setBean({ ...disease.bean, "IDLnCIE": e}) }} onSelectName={(item) => { console.log(item); setNameSelect(item);}}/>
                            </div>
                            {/* {Health} */}
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={disease.bean.Code} onChange={(e: any) => { disease.setBean({ ...disease.bean, 'Code': e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={disease.bean.Name} onChange={disease.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={disease.bean.Description} onChange={disease.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalorp} updateModal={setModalorp} eventModal={importHealthOrphanDiseaseCatalog}>
                        <div className="row">
                            {/* <div className="col-md-12">
                                 <HealthIDEditor render={NameSelect} tipoPresupuesto={30} id={null} edit={true} onSelect={(item) => { console.log(item); setHealth(item); }} onSelectName={(item) => { console.log(item); setNameSelect(item);}}/>
                            </div> */}
                            <div className="col-md-12">
                                <HealthIDTypeCatalog type={30} idSelector={imp.bean.IDHealthIDType} onChange={(e: any) => { imp.setBean({ ...imp.bean, "IDHealthIDType": e }); }}/>
                            </div>
                            <div className="col-md-12">
                                 <FileInput
                                                    Media={imp.bean.Media}
                                                    MediaContext={imp.bean.MediaContext}
                                                    directory='temp'
                                                    label='Archivo'
                                                    onCreate={(Filemap: any) => { imp.setBean({ ...imp.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                 ></FileInput>
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {disease.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}